export default __webpack_public_path__ + "static/media/chat-collapse.34a2b3d2.svg";